import React, { useEffect, useState } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "./About.css";
import aboutImg1 from "../img/PREMIUM.png";
import aboutImg2 from "../img/seekh.png";
import aboutImg3 from "../img/fillet.png";
import aboutImg4 from "../img/chickenparatha.png";
import aboutImg5 from "../img/Chicken Donut.png";
import aboutImg6 from "../img/corncheese.png";
import aboutImg7 from "../img/malairoll.png";
import aboutImg8 from "../img/pizza.png";
import aboutImg9 from "../img/cheeseballs.png";
import Header from "./Header";
import Footer from "./Footer";

const About = () => {
  const [years, setYears] = useState(0);
  const [customers, setCustomers] = useState(0);

  useEffect(() => {
    let yearsTarget = 5;
    let customersTarget = 100;
    let yearsCount = 0;
    let customersCount = 0;

    const yearsInterval = setInterval(() => {
      if (yearsCount < yearsTarget) {
        yearsCount++;
        setYears(yearsCount);
      } else {
        clearInterval(yearsInterval);
      }
    }, 100);

    const customersInterval = setInterval(() => {
      if (customersCount < customersTarget) {
        customersCount += 5;
        setCustomers(customersCount);
      } else {
        clearInterval(customersInterval);
      }
    }, 40);

    return () => {
      clearInterval(yearsInterval);
      clearInterval(customersInterval);
    };
  }, []);

  return (
    <div>
      <Header />
      <div className="about-container">
        <div className="about-wrapper">
          <div className="carousel-container">
            <Carousel
              autoPlay
              infiniteLoop
              showThumbs={false}
              showStatus={false}
              interval={3000}
              dynamicHeight={false}
            >
              <div className="carousel-slide">
                <div className="carousel-pair">
                  <img src={aboutImg1} alt="Quality Food" />
                  <img src={aboutImg3} alt="Hygiene Packaging" />
                  <img src={aboutImg2} alt="Hygiene Packaging" />
                </div>
              </div>
              <div className="carousel-slide">
                <div className="carousel-pair">
                  <img src={aboutImg4} alt="Quality Food" />
                  <img src={aboutImg5} alt="Hygiene Packaging" />
                  <img src={aboutImg6} alt="Hygiene Packaging" />
                </div>
              </div>
              <div className="carousel-slide">
                <div className="carousel-pair">
                  <img src={aboutImg7} alt="Distribution Network" />
                  <img src={aboutImg8} alt="Quality Food Again" />
                  <img src={aboutImg9} alt="Quality Food Again" />
                </div>
              </div>
            </Carousel>
          </div>

         <div className="about-card">
  <h2 className="about-title">Who We Are</h2>
  <p className="about-paragraph">
    <strong>Dzyris Frozen Foods Pvt. Ltd.</strong> is more than just a brand — it's a promise of flavor, freshness, and finesse. With a legacy built on trust, we’re redefining the frozen food experience in India by delivering gourmet-quality meals straight to your plate.
  </p>

  <h2 className="about-title">Our Mission</h2>
  <p className="about-paragraph">
    At Dzyris, we aim to transform everyday meals into extraordinary experiences. Our mission is simple: to make premium-quality, ready-to-eat frozen delights accessible to every household and business. From sourcing the finest ingredients to maintaining an uncompromised cold chain, we ensure every bite bursts with flavor and integrity.
    <br /><br />
    Powered by innovation and driven by passion, we continue to set new benchmarks in hygiene, taste, and convenience — because you deserve nothing less.
  </p>

  <h2 className="about-title">Why Choose Dzyris?</h2>
  <ul className="about-list">
    <li>🌿 <strong>Pure Ingredients:</strong> We use only the highest-grade raw materials, packed with nutrition and taste.</li>
    <li>❄️ <strong>Advanced Cold Chain:</strong> State-of-the-art storage and transport to keep products fresh and safe.</li>
    <li>🎯 <strong>Customer-Centric:</strong> We listen, respond, and evolve based on your needs and feedback.</li>
    <li>🛡️ <strong>Certified Excellence:</strong> FSSAI certified processes backed by rigorous quality control.</li>
  </ul>

  <div className="counters">
    <div className="counter-box">
      <h3 className="counter-number">{years}+</h3>
      <p className="counter-label">Years of Culinary Innovation</p>
    </div>
    <div className="counter-box">
      <h3 className="counter-number">{customers.toLocaleString()}+</h3>
      <p className="counter-label">Satisfied Distributors Nationwide</p>
    </div>
  </div>
</div>

        </div>
      </div>
      <Footer />
    </div>
  );
};

export default About;
